  $("#back-to-top").on("click tap", function(event) {
        $("html, body").animate({
            scrollTop: 0
        }, "slow")
    });
    $(window).scroll(function() {
        if ($(window).scrollTop() >= 600) {
            $("#back-to-top").addClass("visible")
        } else {
            $("#back-to-top").removeClass("visible")
        }
    });

	$( "form.search-bar input" ).focus(function() {
		$(this).attr("placeholder", "");
	});
	$( "form.search-bar input" ).blur(function() {
		$(this).attr("placeholder", "Search all products...");
	});